import * as React from "react";
import { Icon } from "sb-resp-ui";
import { EventCardIcon } from "../../EventCardIcon";
import { createEmptyTooltipIcon } from "./createEmptyTooltipIcon";

export const renderFastMarketIcon = (hasFastMarket: boolean, fastMarketTooltip: string) => {
    const props = {
        className: "rj-ev-list__ev-card-icon--tooltip",
        tooltip: fastMarketTooltip
    };
    return (
        hasFastMarket
            ? <EventCardIcon {...props}>
                <Icon i="i-24-16 i-o-ev-fast-market" />
            </EventCardIcon>
            : createEmptyTooltipIcon()
    )
}